import { MARGEM_MINIMA } from "./reserva-na-ficha";

/** CTA do card de averbação. "Sem margem" só quando o bucket realmente está
 *  zerado. A tabela publicada deixou de ser exigida em 30/09/2026 — o banco
 *  informa as condições do contrato e a Atlas confere só os limites. */
export function rotuloCtaBucketAverbacao(disponivel: number): string {
  // Fracao de centavo nao e' margem (a API recusa): "Sem margem" tambem.
  if (!(disponivel >= MARGEM_MINIMA)) return "Sem margem";
  return "Iniciar averbação";
}

/** CTA do card de um CARTAO (ADR-0014): com reserva deste banco, o proximo
 *  passo e' o lancamento do mes — mesmo com o balde zerado, que e' justamente o
 *  que a reserva ocupou. Sem reserva, reservar pede margem. */
export function rotuloCtaBucketCartao(disponivel: number, temReserva: boolean): string {
  if (temReserva) return "Informar lançamento";
  if (!(disponivel >= MARGEM_MINIMA)) return "Sem margem";
  return "Reservar margem";
}
